<template>
  <div id="discard-from-changes" class="modal custom" role="dialog">
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header no-border">
            <div class="col-xs-12 text-right p-0">
              <img data-dismiss="modal" class="cursor-pointer" src="/static/images/icons/close_icon.svg" alt="close-icon"/>
            </div>
          </div>
          <div class="modal-body p-0 text-center row m-0">
            <div class="col-xs-12 modal-body-text">
              <img class="modal-title text-center mb-20" src="/static/images/icons/delete_warning.svg" alt="delete-icon"/>
              <p class="confirm_title text-center">Are you sure you would like discard the changes?
              </p>
            </div>
          </div>
          <div class="modal-footer xs-flex-column">
            <button type="button" class="btn cancel emergo-white-button xs-mb-10" data-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              class="btn emergo-green-button"
              @click="discardChanges"
            >Discard</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
  methods: {
    discardChanges() {
      this.$emit('navigateBackToListView');
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0px;
}

.modal-footer .btn {
  width: 160px;
}

.mb-40{
  margin-bottom: 40px;
}

.custom .modal-header {
  padding-left: 30px;
  border-bottom: 0 none;
  background-color : white;
  padding-right: 10px;
  padding-bottom: 0;
}

.modal-body {
  font-weight: 500;
  text-align: center;
  padding: 0;
}

.custom .modal-footer{
  border-top: 0 none;
  background-color : white;
  padding-top: 0;
}

.confirm_title{
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 32px;
  word-break: break-word;
}

.modal-content{
  border-radius: 10px !important;
}

.modal-dialog{
  max-width: 500px;
}

.text-start {
  text-align: start;
}

.mb-30 {
  margin-bottom: 30px;
}

.modal-body-text {
  padding-left: 60px;
  padding-right: 60px;
}

@media screen and (max-width: 767px) {
  .xs-mb-10 {
    margin-bottom: 10px;
  }

  .xs-flex-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (min-width: 768px){
  .modal-footer .cancel{
    margin-right: 16px;
  }
}
</style>
